import { ActionTypes } from "../contants/action-types";

const initialState = {};

export const patientDetailsReducer = (state = initialState, {type, payload}) => {
  switch (type) {
    case ActionTypes.SET_PATIENTDETAILS:
      return {...state, ...payload};
    default:
      return state;
  }
}

export const appointmentTypeReducer = (state = initialState, {type, payload}) => {
  switch (type) {
    case ActionTypes.SET_APPOINTMENTTYPE:
      return {...state, ...payload};
    default:
      return state;
  }
}

export const slotSelectionReducer = (state = initialState, {type, payload}) => {
  switch (type) {
    case ActionTypes.SET_SLOTSELECTION:
      return {...state, ...payload};
    default:
      return state;
  }
}

export const insurance = (state = {data:[]}, {type, payload}) => {
  switch (type) {
    case ActionTypes.SET_INSURANCE:
      return {...state, data: [...state.data, payload]};
    default:
      return state;
  }
}